/**
 * LED series resistor: R = (Vs - Vf) / If
 * Accepts suffixes: 5V, 2.1V, 20mA, etc.
 */

import React, { useState, useMemo } from 'react';
import { parseEngineering, inputClass, resultClass, labelClass, hintClass } from './parseEngineering';

const ts = () => new Date().toISOString();

const LedResistor = () => {
  const [vs, setVs] = useState('');
  const [vf, setVf] = useState('');
  const [ifVal, setIfVal] = useState('');

  console.log(`[${ts()}] [LedResistor] render`);

  const vsNum = useMemo(() => parseEngineering(vs), [vs]);
  const vfNum = useMemo(() => parseEngineering(vf), [vf]);
  const ifNum = useMemo(() => parseEngineering(ifVal), [ifVal]);

  const result = useMemo(() => {
    if (vsNum == null || vfNum == null || ifNum == null || ifNum === 0) return null;
    if (vfNum >= vsNum) return null;
    return (vsNum - vfNum) / ifNum;
  }, [vsNum, vfNum, ifNum]);

  const powerDissipation = useMemo(() => {
    if (result == null || ifNum == null) return null;
    return result * ifNum * ifNum;
  }, [result, ifNum]);

  return (
    <div className="space-y-4">
      <p className={hintClass}>
        R = (Vs − Vf) / If. Use suffixes: 5V, 2.1V, 20mA or 0.02.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div>
          <label className={labelClass}>Supply voltage Vs</label>
          <input
            type="text"
            value={vs}
            onChange={(e) => setVs(e.target.value)}
            placeholder="e.g. 5V"
            className={inputClass}
          />
        </div>
        <div>
          <label className={labelClass}>LED forward voltage Vf</label>
          <input
            type="text"
            value={vf}
            onChange={(e) => setVf(e.target.value)}
            placeholder="e.g. 2.1V"
            className={inputClass}
          />
        </div>
        <div>
          <label className={labelClass}>LED current If</label>
          <input
            type="text"
            value={ifVal}
            onChange={(e) => setIfVal(e.target.value)}
            placeholder="e.g. 20mA or 1uA"
            className={inputClass}
          />
        </div>
      </div>
      {result != null && (
        <div className={resultClass}>
          <div>
            <span className="text-gray-600 text-sm">Resistor: </span>
            <span className="font-semibold text-gray-900">{result.toFixed(2)} Ω</span>
            <span className="text-gray-500 text-xs ml-2">(use nearest standard value)</span>
          </div>
          {powerDissipation != null && (
            <div>
              <span className="text-gray-600 text-sm">Power in resistor: </span>
              <span className="font-semibold text-gray-900">{(powerDissipation * 1000).toFixed(2)} mW</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default LedResistor;
